// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidItemSelectQueryVariables = Types.Exact<{
  filter: Types.PotentialBidItemFilter;
}>;


export type BidItemSelectQuery = { __typename?: 'Query', potentialBidItems: Array<{ __typename?: 'BidItem', id: string, displayName: string, products: Array<{ __typename?: 'Product', id: string, name: string }> }> };

export type BidItemSelect_BidItemFragment = { __typename?: 'BidItem', id: string, displayName: string, products: Array<{ __typename?: 'Product', id: string, name: string }> };

export const BidItemSelect_BidItemFragmentDoc = gql`
    fragment BidItemSelect_BidItem on BidItem {
  ...DisplayNamed
  products {
    id
    name
  }
}
    ${DisplayNamedFragmentDoc}`;
export const BidItemSelectDocument = gql`
    query BidItemSelect($filter: PotentialBidItemFilter!) {
  potentialBidItems(filter: $filter) {
    ...BidItemSelect_BidItem
  }
}
    ${BidItemSelect_BidItemFragmentDoc}`;

/**
 * __useBidItemSelectQuery__
 *
 * To run a query within a React component, call `useBidItemSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidItemSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidItemSelectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBidItemSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidItemSelectQuery, BidItemSelectQueryVariables> & ({ variables: BidItemSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidItemSelectQuery, BidItemSelectQueryVariables>(BidItemSelectDocument, options);
      }
export function useBidItemSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidItemSelectQuery, BidItemSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidItemSelectQuery, BidItemSelectQueryVariables>(BidItemSelectDocument, options);
        }
// @ts-ignore
export function useBidItemSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidItemSelectQuery, BidItemSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidItemSelectQuery, BidItemSelectQueryVariables>;
export function useBidItemSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemSelectQuery, BidItemSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidItemSelectQuery | undefined, BidItemSelectQueryVariables>;
export function useBidItemSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemSelectQuery, BidItemSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidItemSelectQuery, BidItemSelectQueryVariables>(BidItemSelectDocument, options);
        }
export type BidItemSelectQueryHookResult = ReturnType<typeof useBidItemSelectQuery>;
export type BidItemSelectLazyQueryHookResult = ReturnType<typeof useBidItemSelectLazyQuery>;
export type BidItemSelectSuspenseQueryHookResult = ReturnType<typeof useBidItemSelectSuspenseQuery>;
export type BidItemSelectQueryResult = Apollo.QueryResult<BidItemSelectQuery, BidItemSelectQueryVariables>;